var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ja-content',{attrs:{"pageTitle":_vm.pageTitle,"pageSubtitle":_vm.pageSubtitle}},[_c('h2',[_vm._v(_vm._s(_vm.$t("performance")))]),_c('ja-performance',{attrs:{"metrics":_vm.performance,"default-metrics":_vm.defaultMetrics}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }